<script setup>

import '@/assets/css/common.css'
import '@/assets/css/survey.css'
import '@/assets/css/noto-sans-kr.css'

import {computed, onMounted} from "vue";

import { useRouter } from "vue-router";
import layoutFull from "@/views/layout/layoutFull.vue";
import layoutNoFooter from "@/views/layout/layoutNoFooter.vue";
import ChatWidget from "@/components/ChatWidget.vue";

const router = useRouter()
const chatbotEnabled = String(process.env.VUE_APP_CHATBOT_ENABLED).toLowerCase() === 'true'
const chatbotApiUrl = process.env.VUE_APP_CHATBOT_API_URL || ''

// router 에서 설정된 레이아웃 조회
const layout = computed(() => {

  let layout = router.currentRoute.value.meta.layout
  if(layout === undefined){
    layout = "layoutContents"
  }
  console.log("-=-------------------------");
  console.log("layout: %s", router.currentRoute.value.meta.layout);
  console.log("bodyClass: %s", router.currentRoute.value.meta.bodyclass);

  return layout
})

// 안드로이드 & DOUB_APP_ANDROID 미포함 체크
function isTargetAndroid() {
  const userAgent = navigator.userAgent
  return /Android|samsungbrowser/i.test(userAgent) && !userAgent.includes('DOUB_APP_ANDROID')
}


// 앱 설치 여부 확인 후 스킴 이동
function openAppIfInstalled() {
  const urlParam = btoa(window.location.href)
  const scheme = `wecare://?url=${urlParam}`

  console.log("Attempting to open app with scheme:", scheme)

  let hasAppOpened = false

  function onVisibilityChange() {
    if (document.hidden || document.webkitHidden) {
      hasAppOpened = true
      cleanup()
    }
  }

  function cleanup() {
    document.removeEventListener('visibilitychange', onVisibilityChange)
    document.removeEventListener('webkitvisibilitychange', onVisibilityChange)
  }

  document.addEventListener('visibilitychange', onVisibilityChange)
  document.addEventListener('webkitvisibilitychange', onVisibilityChange)

  window.location.href = scheme

  setTimeout(() => {
    cleanup()
    // 앱 미설치 시 추가 처리 가능
    if (!hasAppOpened) {
      // 앱이 설치되어 있지 않음 (필요시 처리)
      console.log("App not installed or failed to open.")
    }

  }, 2000)
}

onMounted(() => {
  // 안드로이드 & DOUB_APP_ANDROID 미포함 체크
  if (isTargetAndroid()) {
    openAppIfInstalled()
  }
})

</script>


<template>

  <layout-no-footer v-if="layout === 'layoutNoFooter'"></layout-no-footer>

  <layout-full v-if="layout === 'layoutFull'"></layout-full>

  <!-- 랜딩 페이지: 헤더 없이 컨텐츠만 표시 -->
  <router-view v-if="layout === 'layoutLanding'"></router-view>

  <ChatWidget
    v-if="chatbotEnabled && layout !== 'layoutLanding'"
    :api-base-url="chatbotApiUrl"
  ></ChatWidget>

</template>

<style>

</style>
